<template>
	<v-card class="rounded-lg details-card race-details-card">
		<h1>Detalles</h1>
		<p>
			<v-icon>mdi-flag</v-icon> Distancia total:
			<br />

			<span class="indented"
				><b>
					{{
						Math.floor(Math.round(race.totalDistance / 10) * 10) /
						1000
					}}km
				</b></span
			>
		</p>

		<p class="my-2">
			<v-icon>mdi-calendar</v-icon> Fechas participación:

			<br />

			<span class="indented"
				><b> desde {{ race.startDate | formatDate }}</b></span
			>
			<br />

			<span class="indented">
				<b> hasta {{ race.finishDate | formatDate }} </b>
			</span>
		</p>

		<p class="my-2">
			<v-icon>mdi-crosshairs-gps</v-icon> Coordenadas de inicio:
			<br />

			<span class="indented">
				<b>
					<a
						:href="`https://www.google.com/maps/search/?api=1&query=${startCoordinates}`"
						class="accent--text"
						>{{ startCoordinates }}
					</a>
				</b>
			</span>
		</p>

		<p v-if="race.tags && race.tags.length > 0">
			<v-icon>mdi-tag-multiple</v-icon> Categorías
			<br />

			<span class="indented">
				<v-chip
					v-for="tag in race.tags"
					:key="tag"
					dark
					color="secondary"
					>{{ tag }}</v-chip
				>
			</span>
		</p>

		<div class="card-actions">
			<v-spacer></v-spacer>
			<v-dialog
				content-class="rounded-lg"
				width="600"
				v-model="freeInscriptionDialog"
				v-if="!race.inscribed && race.price === 0"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="rounded-lg"
						x-large
						elevation="0"
						color="accent"
						v-bind="attrs"
						v-on="on"
					>
						Inscribirme
					</v-btn>
				</template>

				<v-card class="rounded-lg pa-4">
					<v-card-title class="headline"
						>Confirmar inscripción</v-card-title
					>

					<v-card-text>
						¿Deseas apuntarte a <b>{{ race.name }}</b> ? Recibirás
						un correo de confirmación al completar la inscripción.
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>

						<v-btn
							color="error"
							class="rounded-lg"
							text
							@click="freeInscriptionDialog = false"
						>
							Cancelar
						</v-btn>

						<v-btn
							color="success"
							dark
							class="rounded-lg"
							elevation="0"
							@click="inscribeInRace"
						>
							Inscribirme
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-btn
				class="rounded-lg"
				x-large
				elevation="0"
				color="accent"
				@click="
					$router.push({
						name: 'ConfirmRacePayment',
						query: { id: race.id },
					})
				"
				v-if="!race.inscribed && race.price > 0"
			>
				Inscribirme por {{ race.price / 100 }}€
			</v-btn>
		</div>
	</v-card>
</template>

<script>
	import axios from "axios";
	import moment from "moment";
	export default {
		props: {
			race: Object,
		},
		data() {
			return {
				freeInscriptionDialog: false,
			};
		},
		computed: {
			startCoordinates() {
				return this.race.id
					? `${this.race.route[0].x},${this.race.route[0].y}`
					: "";
			},
		},
		filters: {
			formatDate(value) {
				return moment(value).locale("es").format("LLL");
			},
		},
		methods: {
			/**
			 * Inscribes the user in the race
			 */
			async inscribeInRace() {
				try {
					this.$emit("loading", true);

					await axios.post("/user/inscription/race", {
						id: this.race.id,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha completado la inscripción en la carrera",
					});

					this.race.inscribed = true;
				} catch (error) {
					//But if it is not possible, redirect the user to the login
					if (error.response && error.response.status === 401) {
						this.$router.push({
							name: "UserLogin",
							params: {
								redirect: this.$route.fullPath,
							},
						});
					} else {
						//In case the server is not working. show an error
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.$emit("loading", false);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.race-details-card {
		padding: 2em;

		h1 {
			margin-bottom: 0.6em;
		}

		p {
			margin: 0;
			text-align: left;
			font-size: 1.1em;
			line-height: 1.8em;
		}

		.indented {
			font-size: 1em;
			margin-left: 2em;
		}

		.card-actions {
			margin-top: 2em;
			display: flex;
			flex-wrap: wrap;
		}
	}
</style>
